import anime from 'animejs';
let transitionHale = 300
let transitionHold = 100

export default{
	
	breath:function(element, inhale, hold1, exhale, hold2, complete) {
		let animation = anime({
			targets: element,
			height: [
				{ value: "100vh", duration: inhale },
				{ value: "100vh", duration: hold1 },
				{ value: "0vh", duration: exhale },
				{ value: "0vh", duration: hold2 },
			],
			
			// autoplay:true,
			// loop:true,

			easing: 'easeInOutSine'
		});

		return animation
	},
	showInhale:function(element, inhale, hold1, exhale, hold2, complete) {
		let animation = anime({
			targets: element,
			opacity: [
				{ value: "1", duration: transitionHale },
				{ value: "1", duration: inhale-transitionHale*2 },
				{ value: "0", duration: transitionHale },
				{ value: "0", duration: hold1 },
				{ value: "0", duration: exhale },
				{ value: "0", duration: hold2 },
			],
			
			// autoplay:true,
			// loop:true,

			easing: 'easeInOutSine'
		});

		return animation
	},
	showExhale:function(element, inhale, hold1, exhale, hold2, complete) {
		let animation = anime({
			targets: element,
			opacity: [
				{ value: "0", duration: inhale },
				{ value: "0", duration: hold1 },
				{ value: "1", duration: transitionHale },
				{ value: "1", duration: exhale - transitionHale*2 },
				{ value: "0", duration: transitionHale },
				{ value: "0", duration: hold2 },
			],
			
			// autoplay:true,
			// loop:true,

			easing: 'easeInOutSine'
		});

		return animation
	},
	showHold:function(element, inhale, hold1, exhale, hold2, complete) {
		let animation = anime({
			targets: element,
			opacity: [
				{ value: "0", duration: transitionHold },
				{ value: "0", duration: inhale-transitionHold*2 },
				{ value: "1", duration: transitionHold },
				{ value: "1", duration: hold1 },
				{ value: "0", duration: transitionHold },
				{ value: "0", duration: exhale-transitionHold*2 },
				{ value: "1", duration: transitionHold },
				{ value: "1", duration: hold2 },
			],
			
			// autoplay:true,
			// loop:true,

			easing: 'easeInOutSine'
		});

		return animation
	},



}